import Handlebars from 'handlebars/lib/handlebars.runtime';
import {globalthis} from '@malt/polyfills/src/common/globalthis';

const globalThis = globalthis();
globalThis.Handlebars = Handlebars;
